<div class="flex flex-col gap-4" [formGroup]="form()">
  <h5 class="x-font-body-3 mt-2 text-[var(--tui-text-primary)]">
    {{ 'request_create.section_counterparty' | translate }}
  </h5>

  <div class="flex flex-col gap-1">
    <tui-textfield
      tuiChevron
      [stringify]="stringifyCounterparty"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <label tuiLabel>
        {{ 'request_create.counterparty_id' | translate }} *
      </label>

      <input tuiSelect formControlName="counterpartyOwnerId" />
      <ng-template tuiDropdown>
        <tui-data-list>
          @for (counterparty of counterparties(); track counterparty.id) {
            <button tuiOption type="button" [value]="counterparty.id">
              {{ counterparty.name }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>
    <tui-error
      formControlName="counterpartyOwnerId"
      [order]="['required']"
    ></tui-error>
  </div>
  @if (
    permissionService.canLogistViewCounterpartyAccessPointFieldInRequestCreation$
      | async
  ) {
    <div class="flex flex-col gap-1">
      <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
        <label tuiLabel>{{
          'request_create.nearest_branch' | translate
        }}</label>
        <input tuiInput maxlength="100" formControlName="nearestBranch" />
      </tui-textfield>
    </div>
  }

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.project_number' | translate }}</label>
      <input tuiInput maxlength="32" formControlName="projectNumber" />
    </tui-textfield>
  </div>

  <h5 class="x-font-body-3 mt-2 text-[var(--tui-text-primary)]">
    {{ 'request_create.section_contract' | translate }}
  </h5>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.contract' | translate }}</label>
      <input tuiInput maxlength="256" formControlName="contract" />
    </tui-textfield>
  </div>

  <div class="grid gap-4 md:grid-cols-3">
    <div class="flex flex-col gap-1">
      <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
        <label tuiLabel>
          {{ 'request_create.contract_date' | translate }}
        </label>

        <input tuiInputDate formControlName="contractDate" />
        <tui-calendar *tuiDropdown />
      </tui-textfield>
    </div>

    <div class="flex flex-col gap-1">
      <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
        <label tuiLabel>
          {{ 'request_create.contract_planned_end_date' | translate }}
        </label>

        <input tuiInputDate formControlName="contractPlannedEndDate" />
        <tui-calendar *tuiDropdown />
      </tui-textfield>
    </div>

    <div class="flex flex-col gap-1">
      <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
        <label tuiLabel>
          {{ 'request_create.contract_early_end_date' | translate }}
        </label>

        <input tuiInputDate formControlName="contractEarlyEndDate" />
        <tui-calendar *tuiDropdown />
      </tui-textfield>
    </div>
  </div>

  <h5 class="x-font-body-3 mt-2 text-[var(--tui-text-primary)]">
    {{ 'request_create.section_lessee' | translate }}
  </h5>

  <div class="grid gap-4 md:grid-cols-2">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.subj_name' | translate }}</label>
      <input tuiInput maxlength="256" formControlName="subjName" />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.subj_inn' | translate }}</label>
      <input tuiInput maxlength="256" formControlName="subjInn" />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.subj_fullname' | translate }}</label>
      <input tuiInput maxlength="256" formControlName="subjFullname" />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.subj_phone' | translate }}</label>
      <input tuiInput maxlength="256" formControlName="subjPhone" />
    </tui-textfield>
  </div>
</div>
